import { Link } from '@reach/router';
import React, { useContext } from 'react';
import { NotebookContext } from '../../../context/NotebookContext';
import client from '../../../lib/client';
import { deleteNoteMutation, notesQuery } from '../../../queries/notes';
import {
  NoteDeleteMutation,
  NoteDeleteMutationVariables
} from '../../../queries/__generated__/NoteDeleteMutation';
import { ButtonIconRound, Card, CardSegment } from '../../ui';
import MeasurementsBySubject from './MeasurementsBySubject';

interface DataCardProps {
  note: {
    id: string;
    measurements: {
      subject: {
        id: string;
      };
      tracker: {
        id: string;
      };
      value: number;
    }[];
    subjects: {
      id: string;
      name: string;
    }[];
  };
  isEntryAuthor: boolean;
}

const DataCard: React.FC<DataCardProps> = ({ note, isEntryAuthor }) => {
  const { notebook } = useContext(NotebookContext);

  async function deleteNote() {
    const confirmDelete = confirm('Are you sure you want to delete this note?');
    if (confirmDelete) {
      await client
        .mutate<NoteDeleteMutation, NoteDeleteMutationVariables>({
          mutation: deleteNoteMutation,
          variables: { input: { id: note.id } },
          awaitRefetchQueries: true,
          refetchQueries: [
            {
              query: notesQuery,
              variables: { input: { notebookId: notebook.id, first: 20 } }
            }
          ]
        })
        .then(data => {
          const { errors } = data;
          if (errors) {
            throw new Error(errors[0].message);
          }
        });
    }
  }

  return (
    <div data-testid="entry-data-card">
      <MeasurementsBySubject measurements={note.measurements} subjects={note.subjects} />
    </div>
  );
};

export default DataCard;
